import { render } from "./Persons.vue?vue&type=template&id=af1e883e"
import script from "./Persons.vue?vue&type=script&lang=js"
export * from "./Persons.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./Persons.vue?vue&type=style&index=1&id=af1e883e&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\frontCode\\GN-Students\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__